// @flow

import * as React from 'react';
import R from 'ramda';

import { ACCESS_CONTROL_PROPS } from '../../support/accessControlConstants';
import AccessControlWrapper from './AccessControlWrapper';
import { MessageBox } from '../core';

type Props = {
  /**
   * Title to be displayed
   */
  title: string | React.Element<any>,

  /**
   * Message to show when access is allowed
   */
  text: string | React.Element<any>,

  /**
   * Determines if the message box should be rendered or not.
   * True will not render.
   */
  accessDenied: boolean,

  /**
   * Message to show when access is denied
   */
  accessDeniedMessage: string | React.Element<any>
};

/**
 * Displayed when access is denied. Nothing will be rendered if the user
 * has access based on the required accessResources and permission
 */
class AccessMessageBox extends React.PureComponent<Props> {
  static defaultProps = {
    title: 'You do not have access.',
    text: ''
  };

  render() {
    const { accessDeniedMessage, accessDenied, title, text } = this.props;

    return accessDenied ? (
      <div className="access-message-box">
        <img
          className="access-message-box-image"
          src="/static/images/locked.svg"
        />
        <div className="access-message-box-text-container">
          <div className="access-message-box-title">{title}</div>
          <div>{accessDeniedMessage}</div>
        </div>
      </div>
    ) : text ? (
      <MessageBox
        {...R.omit(['accessDeniedMessage', 'accessDenied'], this.props)}
      />
    ) : null;
  }
}

type WrapperProps = {
  accessResources: Array<string>,
  permission: number,

  /**
   * Title to be displayed
   */
  title: string | React.Element<any>,

  /**
   * Message to show
   * NOTE: Copy functionality from core/MessageBox if that is needed
   */
  text: string | React.Element<any>,

  /**
   * Determines if the message box should be rendered or not.
   * True will not render.
   */
  accessDenied: boolean
};

/**
 * Displayed when access is denied. Nothing will be rendered if the user
 * has access based on the required accessResources and permission
 */
export default class AccessMessageBoxWrapper extends React.PureComponent<
  WrapperProps
> {
  render() {
    const { accessResources, permission } = this.props;
    return (
      <AccessControlWrapper
        accessResources={accessResources}
        permission={permission}
        accessDeniedPropName="accessDenied"
      >
        <AccessMessageBox {...R.omit(ACCESS_CONTROL_PROPS, this.props)} />
      </AccessControlWrapper>
    );
  }
}
